<template>
  <div>
    <!-- <div class="step-single upcoming" v-show="step.upcoming">
      <div class="step-title">{{ T__("Event type details") }}</div>
    </div> -->
    <div
      class="step-single form active"
      v-show="step.form"
      :id="'service_form_step' + step.id"
    >
      <div class="step-title">{{ T__("Event Type Notification") }}</div>
      <div class="form" @submit.prevent>
        <form-row :validator="$v.form.name">
          <label for="form_name">
            {{ T__("Invitee notification type")
            }}<abbr class="required" title="required">*</abbr>
            <a
              href="https://help.wpcal.io/en/article/what-are-event-type-notification-options-how-does-it-work-how-to-change-it-13cie5k/?utm_source=wpcal_plugin&utm_medium=contextual"
              target="_blank"
              class="icon-q-mark"
            ></a>

            <em>{{ T__("required") }}</em>
          </label>
          <span class="txt-help">
            {{
              T__(
                "Select how the booking notification and reminder emails will be sent "
              )
            }}
          </span>
          <ul class="selector block">
            <li>
              <input
                id="form_invitee_notify_by_cal"
                name="form_invitee_notify_by"
                type="radio"
                v-model="form.invitee_notify_by"
                value="calendar_invitation"
              />
              <label for="form_invitee_notify_by_cal">
                <div class="txt-h4">{{ T__("Calendar invitation") }}</div>
                <div class="txt-help">
                  A calendar invitation will be sent directly from the calendar
                  app eg. Google Calendar. If the 'Add bookings to...' calendar
                  is not set, it will fallback to email.
                  <a
                    href="https://help.wpcal.io/en/article/what-are-event-type-notification-options-how-does-it-work-how-to-change-it-13cie5k/?utm_source=wpcal_plugin&utm_medium=contextual#1-what-are-event-type-notification-options-for-invitee-and-how-does-it-work"
                    target="_blank"
                    >Learn more</a
                  >.
                </div>
              </label>
            </li>
            <li>
              <input
                id="form_invitee_notify_by_email"
                name="form_invitee_notify_by"
                type="radio"
                v-model="form.invitee_notify_by"
                value="email"
              />
              <label for="form_invitee_notify_by_email">
                <div class="txt-h4">{{ T__("Email") }}</div>
                <div class="txt-help">
                  An email notification with the details of their booking will
                  be sent to the invitees.
                </div>
              </label>
            </li>
          </ul>
        </form-row>

        <!-- {{ $v.step5 }} -->
        <div class="wpc-form-row">
          <button
            v-if="view == 'edit'"
            type="button"
            class="wpc-btn primary lg"
            :disabled="!create_or_update_btn_is_enabled"
            @click="$emit('submit-form', 5)"
          >
            {{ T__("Save") }}
          </button>
          <button
            v-if="view == 'edit'"
            type="button"
            @click="$emit('edit-view-toggle-steps')"
            class="wpc-btn tert-link sm mt10 center"
          >
            {{ T__("Cancel") }}
          </button>
        </div>
      </div>
    </div>
    <div class="step-single summary" v-show="step.summary">
      <div class="step-title">
        <span>{{ T__("Event Type Notification") }}</span>
        <a @click="$emit('set-active-step-and-toggle', 5)">{{ T__("EDIT") }}</a>
      </div>
      <div class="step-summary-content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceFormStep5",
  components: {},
  props: {
    view: {
      type: String
    },
    step: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    create_or_update_btn_is_enabled: {},
    $v: {}
  },
  data() {
    return {};
  },
  methods: {},
  watch: {},
  mounted() {}
};
</script>
